// React import
import * as React from 'react'
// Standard layout imports
import { IActivityModel } from 'src/Entities/Activity/Activity';

import Title from 'src/components/Title';
import { Columns, Column } from 'src/components/Layout/Grid';
import Icon from 'src/components/Icon';
import { format } from 'date-fns'
import Button from 'src/components/Button';
import { Link, Redirect } from 'react-router-dom';
import Tag from 'src/components/Tag';

interface IProps {
  activities: IActivityModel[]
  setSelectedActivity: (detailKursuId: number)  => void;
}
interface IState{
  shouldRedirectToCourse: boolean
}

class SameTitleActivities extends React.Component<IProps,IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {shouldRedirectToCourse: false}
    this.renderActivity = this.renderActivity.bind(this);
  }

  public renderActivity(activity: IActivityModel, index: number) {
    const {detailKursusId, fiuNo, courseTitle, courseLocation, startDate, tag} = activity;

    return (
      <div
        onClick={() => this.props.setSelectedActivity(detailKursusId)}
        key={fiuNo}
        className="fs-normal"
        style={{
          textDecoration: 'none',
          color: 'black',
          cursor:"pointer",
        }}
      >
        <div className="py2 px3 mb1 has-background-white">
          <Columns gutter="default" alignItems="center">
            <Column md="fill" className="f5">
              <div className="b">{courseTitle}</div>
              Sted: {courseLocation}
            </Column>
            <Column md="auto">
            {tag ?  <Tag className="mr1" color={tag.color}  >{tag.children} </Tag> : null  }
              <span className="b f6">{format(new Date(startDate), 'dd.MM.yyyy')}</span>
              <Button
                size="micro"
                className="ml2"
                color="gray"
                rounded={true}
              >
                <Icon name="chevron-right" />
              </Button>
            </Column>
          </Columns>
        </div>
      </div>
    );
  }

  public render() {
    return (
      <div>
        <Title className="mb2">Andre kurser med samme titel</Title>
        {this.props.activities.map(this.renderActivity)}
        {this.state.shouldRedirectToCourse ? <Redirect to="/kursus/" push={true} />: null}
      </div>
    );
  }
}

export default SameTitleActivities



// WEBPACK FOOTER //
// ./src/Pages/CoursePortal/Activityies/Activity/sameTitelCourses.component.tsx